<template>
  <v-snackbar
    v-model="isVisible"
    :color="$store.state.notification.color"
  >
    {{ $store.state.notification.text }}

    <template v-slot:action="{ attrs }">
      <v-btn
        icon
        v-bind="attrs"
        @click.stop="isVisible = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'TheNotification',

  computed: {
    isVisible: {
      get() {
        return this.$store.state.notification.isVisible;
      },
      set() {
        this.$store.commit('notification/HIDE_NOTIFICATION');
      },
    },
  },
};
</script>
